import Cookies from "universal-cookie";
import {loadConfig} from "../config/configLoader";

const cookies = new Cookies();

const COMMON_HEADERS = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Access-Control-Allow-Origin": "*"
};

const CONSUMER_HEADER = {
    "X-Consumer-Key": "Handdo Managers"
};

export const fetchWithoutToken = async (endpoint, data = null, method = 'GET') => {
    const {authUrl} = await loadConfig();
    const url = `${authUrl}/${endpoint}`;

    const options = {
        mode: "cors",
        method,
        headers: {
            ...COMMON_HEADERS,
            ...CONSUMER_HEADER
        }
    };

    if (method !== 'GET' && data) {
        options.body = JSON.stringify(data);
    }

    return fetch(url, options);
};

export const fetchWithToken = async (endpoint, data = null, method = 'GET') => {
    const { baseUrl } = await loadConfig();
    const token = cookies.get("token");
    const url = `${baseUrl}/${endpoint}`;

    const isFormData = data instanceof FormData;

    const headers = isFormData
        ? { Authorization: `Bearer ${token}` } // ⚠️ NO incluir Content-Type manualmente
        : {
            ...COMMON_HEADERS,
            Authorization: `Bearer ${token}`,
        };

    const options = {
        mode: "cors",
        method,
        headers,
        body: method !== 'GET' && data
            ? isFormData
                ? data            // para FormData, lo dejamos tal cual
                : JSON.stringify(data)
            : undefined
    };

    return fetch(url, options);
};
export const fetchWithTokenJson = async (endpoint, data) => {
    const { baseUrl } = await loadConfig();
    const token = cookies.get("token");
    const url = `${baseUrl}/${endpoint}`;

    const options = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json" // ✅ necesario
        },
        body: JSON.stringify(data)
    };

    return fetch(url, options);
};
